export enum FeatureToggle {
  storeInterventions = 'rt_store_interventions',
}
